import { render, staticRenderFns } from "./ProductGroupDeleteModal.vue?vue&type=template&id=0da0c967&"
import script from "./ProductGroupDeleteModal.vue?vue&type=script&lang=js&"
export * from "./ProductGroupDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports